import { ArticleBigList } from "app/articles/components/ArticleBigList"
import { BrandList } from "app/brands/components/BrandList"
import { card, colContainer, colNarrow } from "app/common/components/Containers"
import { Paging } from "app/common/components/Paging"
import { RouteMgr } from "app/common/routes"
import { optionalRender } from "app/common/ui/optionalRender"
import { PaginationModelItem } from "app/common/utilities/paging"
import { ArticleVM, BrandListVM } from "app/models"
import { BrandSearchFilter } from "app/search/codecs"
import { PagedSearchResults } from "app/search/codecs/map"
import { ActiveSearchFilters } from "app/search/components/ActiveSearchFilters"
import { FilterSelector } from "app/search/components/FilterSelector"
import { LocaleD } from "db"
import { array, readonlyArray } from "fp-ts"
import { pipe } from "fp-ts/function"
import useTranslation from "next-translate/useTranslation"
import { FC } from "react"
import { apply, tw } from "twind"

const h2 = apply`(text-xl font-bold) (mb-4 pb-3) (border-b-1 border-gray-300)`

export interface CategoryDetailsProps {
  articles: readonly ArticleVM[]
  brands: PagedSearchResults<BrandListVM>
  filters: BrandSearchFilter[]
  locale: LocaleD
  paginationModel: PaginationModelItem[]
  slugPath: Array<string>
}

export const CategoryDetails: FC<CategoryDetailsProps> = ({
  articles,
  brands,
  filters,
  locale,
  paginationModel,
  slugPath,
}) => {
  const { t: tArticles } = useTranslation("articles")

  const { t: tBrands } = useTranslation("brands")

  return (
    <div className={tw(colContainer)}>
      <div className={tw(colContainer)}>
        <div className={tw(card, `flex(& col) gap-4`)}>
          {pipe(
            brands.facets,
            optionalRender((facetMap) => (
              <>
                <ActiveSearchFilters
                  createUrl={(filters) => RouteMgr.CategoryPage({ filter: filters })}
                  facetMap={facetMap}
                  filters={filters}
                />

                <FilterSelector
                  createUrl={(filter) =>
                    RouteMgr.CategoryPage({
                      filter,
                      slugPath,
                    })
                  }
                  facetMap={facetMap}
                  filters={filters}
                />
              </>
            ))
          )}
        </div>

        <div className={tw(card)}>
          {array.isNonEmpty(brands.data) && (
            <div>
              <h2 className={tw(h2)}>{tBrands("brands")}</h2>

              <BrandList brands={brands.data} />

              <Paging
                getPageUrl={(page) =>
                  RouteMgr.CategoryPage({
                    filter: filters,
                    page,
                    slugPath,
                  })
                }
                pagingInfo={paginationModel}
              />
            </div>
          )}
        </div>
      </div>

      <div className={tw(colNarrow)}>
        {readonlyArray.isNonEmpty(articles) && (
          <div className={tw(card)}>
            <h2 className={tw(h2)}>{tArticles("articles")}</h2>

            <ArticleBigList articles={articles} locale={locale} />
          </div>
        )}
      </div>
    </div>
  )
}
